import PropTypes from 'prop-types'
import React from 'react'

import SocialButton from './SocialButton'

const FOLLOW_LINKS = {
  facebook: 'https://www.facebook.com/snipscompany',
  twitter: 'https://twitter.com/snips',
  linkedin: 'https://www.linkedin.com/company-beta/5024356/',
  instagram: 'https://www.instagram.com/snips.ai/'
}

const SocialFollowButtons = ({ url, text, networks, analyticsExtra }) => (
  <div className='social-share-buttons'>
    {networks.map(network => {
      const followLink = FOLLOW_LINKS[network]
      if (!followLink) return null
      return (
        <SocialButton
          key={network}
          url={followLink}
          shareText={text}
          icon={network}
          forceAnchorElement={network === 'email'}
          target={network === 'email' ? undefined : '_blank'}
          analyticsExtra={analyticsExtra}
        />
      )
    })}
  </div>
)

SocialFollowButtons.propTypes = {
  networks: PropTypes.array.isRequired,
  // passed along to SocialButton component
  analyticsExtra: PropTypes.string
}

SocialFollowButtons.defaultProps = {
  networks: ['facebook', 'twitter', 'linkedin']
}

export default SocialFollowButtons



// WEBPACK FOOTER //
// ./frontend/scripts/react/components/SocialFollowButtons.js